import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

import './Menu.scss';

import LogoDev from '../../assets/_images/logo/logo-uninter-DEV.png';
import LogoQA from '../../assets/_images/logo/logo-uninter-qa.png';
import Logo from '../../assets/_images/logo/logo-uninter.png';

import AuthService from '../../services/Auth';
import MenuItem from './MenuItem';
import enviromment from '../../environment';
import { useContainerContext } from '../../contexts/ContainerContext';

function Menu() {

    const { desktopMenuAberto, mobileMenuAberto,
        toggleMobileMenuAberto, toggleDesktopMenu } = useContainerContext();
    const [menuAbertoId, setMenuAberto] = useState(0);

    function toggleListaMenu(menuId) {
        setMenuAberto(menuId === menuAbertoId ? 0 : menuId);
    }

    function handleNavigateHome() {
        toggleDesktopMenu();
        handleNavigate();
    }

    function handleNavigate() {
        if (mobileMenuAberto)
            toggleMobileMenuAberto();
    }

    let menus = AuthService.getMenu();
    if (Array.isArray(menus)) {
        menus = menus.sort((a, b) => a.nome > b.nome ? 1 : (a.nome < b.nome ? -1 : 0));
    }

    return (
        <div className="side-left-menu">
            <div className={`${mobileMenuAberto ? 'menu-open-mobile' : ''}`}>
                <div className={`wrapper uninter-menu-base`}>
                    <nav id="sidebar" className={`${!desktopMenuAberto ? 'sidebar-small' : ''}`}>
                        <div className="sidebar-header">
                            <div className="uninter-dark">
                                {
                                    desktopMenuAberto &&
                                    <Link to="/" className="navbar-brand ">
                                        <img alt="" src={`${enviromment.ambiente === 'DEV' ? LogoDev : (enviromment.ambiente === 'QA' ? LogoQA : Logo)}`} width="148" height="35" />
                                    </Link>
                                }
                                <button className="btn btn-lg btn-link navbar-toggler-desktop btn-hamburguer" type="button" onClick={() => handleNavigateHome()}>
                                    <i className="fa fa-bars uninter-detalhes-yellow" aria-hidden="true">
                                    </i>
                                </button>
                            </div>
                        </div>

                        <ul className="list-unstyled components menu">

                            <li>
                                <NavLink to="/" exact={true} className="d-flex menu-link" activeClassName='menu-aberto' onClick={() => setMenuAberto(0)}>
                                    <i className="fa fa-home"></i>
                                Início
                            </NavLink>
                                <div className={`space`}></div>
                                {
                                    menus
                                        .filter(menu => (menu.visivel || menu.filhos.length > 0) && menu.nome !== 'Início')
                                        .map(menu =>
                                            <MenuItem
                                                key={menu.id}
                                                {...menu}
                                                menuAbertoId={menuAbertoId}
                                                toggleMenu={toggleListaMenu}
                                                navigate={handleNavigate}
                                            />
                                        )
                                }
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            {
                mobileMenuAberto &&
                <div className="menu-overlay" onClick={() => toggleMobileMenuAberto()}></div>
            }
        </div>
    )
}

export default Menu;